import { YOO_FINDS_H5_CDN_URL } from "@/common/domains";

const baseUrl = `${YOO_FINDS_H5_CDN_URL}/h5/activity/bf2025`;

export const BF2025_ACTIVITY_BANNER = `${baseUrl}/bf-activity-banner.png`;
export const BF2025_GMV_BANNER = `${baseUrl}/bf-2025-gmv-banner.png`;
export const BF2025_AD_BANNER = `${baseUrl}/bf-2025-ad-banner.png`;
export const BF2025_RANKING_REWARDS = `${baseUrl}/ranking-rewards_v2.png`;
export const BF2025_MONEY_ICON = `${baseUrl}/money-icon.png`;
export const BF2025_SPARK = `${baseUrl}/spark.png`;
export const BF2025_MY_WALLET_GUIDE = `${baseUrl}/my-wallet-guide_v2.png`;
export const BF2025_PAYMENT_INFO_GUIDE = `${baseUrl}/payment-info-guide.png`;
export const BF2025_RANKING_REWARDS_AD = `${baseUrl}/ranking-rewards-ad_v4.png`;

export const BF2025_LIGHTNING = `${baseUrl}/lightning.png`;
export const BF2025_TAKE_PART = `${baseUrl}/take-part_v2.png`;

export const BANNER_BG = `${baseUrl}/banner-bg-v1.png`;
export const BF_LOGO = `${baseUrl}/bf-logo-v1.png`;
export const DOWN_ARROW = `${baseUrl}/down-arrow.png`;

export const RULES_DATA = [
  {
    rank: "Ranks #1",
    reward: "Gets $3000",
    minRequirement: "GMV ≥ 120000",
  },
  {
    rank: "Ranks #2",
    reward: "Gets $2000",
    minRequirement: "GMV ≥ 100000",
  },
  {
    rank: "Ranks #3",
    reward: "Gets $1000",
    minRequirement: "GMV ≥ 50000",
  },
  {
    rank: "Ranks #4 - #10",
    reward: "Gets $500",
    minRequirement: "GMV ≥ 20000",
  },
  {
    rank: "Ranks #11- #20",
    reward: "Gets $200",
    minRequirement: "GMV ≥ 10000",
  },
  {
    rank: "Ranks #21- #30",
    reward: "Gets $100",
    minRequirement: "GMV ≥ 5000",
  },
];
export const RULES_STEP_LIST = [
  {
    title: "Home-Profile-Services-My Wallet",
    contentUrl: BF2025_MY_WALLET_GUIDE,
  },
  {
    title: "Fill in your payment account information",
    contentUrl: `${baseUrl}/step-2.png`,
  },
];

export const BF2025_APP_QR_CODE = `${baseUrl}/app-qr-code-v3.png`;
